import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import { useState, useEffect } from 'react';
// @mui
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

export default function RHFAutocomplete({
  name,
  label,
  placeholder,
  helperText,
  type,
  onChange: customOnChange,
  onInputChange: customOnInputChange,
  ...other
}) {
  const { control, setValue, watch } = useFormContext();
  const fieldValue = watch(name);
  const [inputValue, setInputValue] = useState(
    typeof fieldValue === 'string' ? fieldValue : ''
  );

  useEffect(() => {
    if (type === 'text-only') {
      setInputValue(typeof fieldValue === 'string' ? fieldValue : '');
    }
  }, [fieldValue, type]);

  const isAlphabetOnly = (value) => /^[a-zA-Z\s]*$/.test(value);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        const textOnlyProps =
          type === 'text-only'
            ? {
                inputValue,
                onInputChange: (event, newInputValue, reason) => {
                  if (!isAlphabetOnly(newInputValue)) {
                    return;
                  }
                  setInputValue(newInputValue);
                  if (customOnInputChange) {
                    customOnInputChange(event, newInputValue, reason);
                  }
                },
              }
            : customOnInputChange
            ? { onInputChange: customOnInputChange }
            : {};

        return (
          <Autocomplete
            {...field}
            value={field.value ?? null}
            onChange={(event, newValue, reason, details) => {
              if (type === 'text-only' && newValue && !isAlphabetOnly(newValue)) {
                return;
              }
              setValue(name, newValue, { shouldValidate: true, shouldDirty: true });
              if (type === 'text-only') {
                setInputValue(typeof newValue === 'string' ? newValue : '');
              }
              if (customOnChange) {
                customOnChange(event, newValue, reason, details);
              }
            }}
            {...textOnlyProps}
            {...other}
            renderInput={(params) => (
              <TextField
                label={label}
                placeholder={placeholder}
                error={!!error}
                helperText={error ? error?.message : helperText}
                required={other.required}
                {...params}
              />
            )}
          />
        );
      }}
    />
  );
}

RHFAutocomplete.propTypes = {
  helperText: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  onChange: PropTypes.func,
  onInputChange: PropTypes.func,
};
